<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="10">
        <v-form onsubmit="return false">
          <v-card>
            <v-card-title>Password Reset</v-card-title>
            <v-card-text>
              <v-text-field
                v-on:keyup.enter="sendPasswordResetLink()"
                name="email"
                label="Email Address"
                v-model="email"
                type="text"
                outlined
              ></v-text-field>
            </v-card-text>

            <v-alert dismissible close-text="Close Alert" border="left"  v-model="userMessage" elevation="9" :type="messageType">{{
              passwordResetMessage
            }}</v-alert>
          </v-card>
        </v-form>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="10">
        <v-card-subtitle class="text-right">
          <v-btn color="success" @click="sendPasswordResetLink()">Send Reset Password Link</v-btn>
        </v-card-subtitle>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template> 

<script>
import serverFunctions from "@/functions/serverFunctions";

export default {
  name: "SendPasswordResetLink",
  computed: {
    userMessage() {
      if (this.passwordResetMessage && this.passwordResetMessage.length > 0) {
        return true;
      }
      return false;
    },
  },
  data: () => ({
    email: "",
		messageType: "success",
		passwordResetMessage: ""
  }),
  methods: {
    async sendPasswordResetLink() {

			if(this.email.length == 0) {
				this.messageType = "error";
				this.passwordResetMessage = "Enter an email address";
				return;
			}

      let sendPasswordResetLinkRequest = serverFunctions.getSendPasswordResetLinkRequest(this.email);

      await serverFunctions.getPostResponse("/sendPasswordReset", sendPasswordResetLinkRequest)

			this.messageType = "success";
			this.passwordResetMessage = "An email containing a password reset link has been sent to address entered, if it is registered with this site.";
    },
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
